import { call, put, takeEvery } from "redux-saga/effects";
import { phongHocTrongKyApi } from "../../../api/category/phongHocTrongKyApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { ePhongHocTrongKyActionIds, IPhongHocTrongKyActionTypes } from "../../action-types/category/IPhongHocTrongKyActions";
import { rootActions } from "../../actions/rootActions";
import { IPlanPhongHocTrongKyAsyncRequest } from "../../../model/request/category/IPlanPhongHocTrongKyAsyncRequest";
import { IPlanPhongHocTrongKy } from "../../../model/respone/category/IPlanPhongHocTrongKy";

const mainAction = rootActions.category.phongHocTrongKy;

export function* phongHocTrongKySaga() {
    yield takeEvery(ePhongHocTrongKyActionIds.LOAD_START, loadWorker);
    yield takeEvery(ePhongHocTrongKyActionIds.ASYNC_START, asyncWorker);
    yield takeEvery(ePhongHocTrongKyActionIds.UPDATE_START, updateWorker);
}

function* loadWorker(action: IPhongHocTrongKyActionTypes) {
    const payload = action.payload as {hoc_ky: number, nam_hoc: string};
    const res: IBaseRespone = yield call(phongHocTrongKyApi.SelectByHocKyAndNamHoc, payload.hoc_ky, payload.nam_hoc);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
    }
}

function* asyncWorker(action: IPhongHocTrongKyActionTypes) {
    debugger;
    const payload = action.payload as IPlanPhongHocTrongKyAsyncRequest;
    const res: IBaseRespone = yield call(phongHocTrongKyApi.Async, payload);
    if (res.is_success) {
        yield put(mainAction.ASYNC_SUCCESS("Thành công"));
    } else {
        yield put(mainAction.ASYNC_ERRR(res.message ?? "Có lỗi"));
    }
}

function* updateWorker(action: IPhongHocTrongKyActionTypes) {
    const payload = action.payload as IPlanPhongHocTrongKy;
    const res: IBaseRespone = yield call(phongHocTrongKyApi.Update, payload);
    if (res.is_success) {
        yield put(mainAction.UPDATE_SUCCESS(res.data));
    } else {
        yield put(mainAction.UPDATE_ERRR(res.message ?? "Có lỗi"));
    }
}